import { domToReact } from "html-react-parser";
import { PostImageContainer } from "../styles/postStyles";
import InlineForm from "../components/Form/InlineForm";

export const postOptions = {
  replace: ({ attribs, children }) => {
    if (!attribs) {
      return;
    }
    if (attribs.id && attribs.id.startsWith("attachment_")) {
      return (
        <PostImageContainer>
          {domToReact(children, postOptions)}
        </PostImageContainer>
      );
    }
    if (
      children.length === 1 &&
      children[0]?.data === "[et_bloom_inline optin_id=optin_10]"
    ) {
      return (
        <>
          <InlineForm></InlineForm>
        </>
      );
    }
  },
};
